<template>
<div>基本账户</div>
</template>

<script>
  export default {
    name: "basic-account"
  }
</script>

<style scoped>

</style>
